import {Heading, Text} from '@constellation/core';
import {type VFC} from 'react';
import {StyledBox} from './style.js';

type Props = {
  serviceName?: string;
  header?: string;
  stepCounter?: string;
  isNotShownStepCounter?: boolean;
};

const JourneyHeader: VFC<Props> = (props) => {
  const {serviceName, header, isNotShownStepCounter, stepCounter} = props;

  return (
    <StyledBox bgColor='none' padding='none'>
      <Text weight='bold'>{serviceName}</Text>
      <Heading as='h1' color='brand' marginBottom='02' marginTop='03' size='s7'>
        {header}
      </Heading>
      {!isNotShownStepCounter && <Text marginBottom='08'>{stepCounter}</Text>}
    </StyledBox>
  );
};

JourneyHeader.defaultProps = {
  serviceName: 'Online quotation tool',
  header: 'Tell us about your business',
  stepCounter: 'Your answers will help us create an example quote for you.',
  isNotShownStepCounter: false,
};

export default JourneyHeader;
